import React, { Component } from '../lib/react'

export default class IFrame extends Component {
  render() {
    const onload = this.props.onload || function(){};

    return (
      <iframe
        className={this.props.className}
        onLoad={() => onload()}
        type="text/html"
        src={this.props.url}
        frameBorder="0"
        title={this.props.title}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/IFrame.js